export default __webpack_public_path__ + "static/media/areaTotal.3e2bcdd5.png";